/**
 * TanStack Query の QueryClient（Unit 006 データ取得層）
 *
 * 既定方針:
 * - retry: 4xx（特に 401/403）は再試行しない。5xx のみ最大2回。
 *   → 401 再試行による /login リダイレクト多重発火（api.ts のレスポンスインターセプタ）を防ぐ。
 * - refetchOnWindowFocus: false（フォーカスで勝手に再取得しない＝既存挙動・表示同一性を優先）。
 * - staleTime: 30秒（過度な再取得を抑制）。マスタ系は Hook 側で長めに上書きする。
 */
import { QueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

/** エラーから HTTP ステータスを取り出す（axios 以外は 0） */
function httpStatus(error: unknown): number {
  if (error instanceof AxiosError) {
    return error.response?.status ?? 0
  }
  return 0
}

/**
 * クエリの再試行判定（純関数・テスト容易性のため分離）。
 * 4xx（特に 401/403）・ネットワークエラー(status 0)は再試行しない。5xx のみ最大2回。
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  return httpStatus(error) >= 500 && failureCount < 2
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: false,
    },
  },
})
